import React, { useState, useEffect } from "react";

import Charts from "../../Charts";
import getStudentsData from "../DataFromBackend/StudentsData";

import "./styles.scss";

const Chart1 = ({ applications }) => {
  const [notas, setNotas] = useState(null);

  const studentsData = getStudentsData(applications);

  useEffect(() => {
    const fields = [0, 0, 0, 0, 0, 0, 0]; // position 5: maior item da escala.         position 6: menor item da escala.
    let count = 0;

    for (let students of studentsData) {
      let { nota } = students;

      if (nota <= 3) fields[4]++;
      else if (nota <= 5) fields[3]++;
      else if (nota <= 7) fields[2]++;
      else if (nota <= 9) fields[1]++;
      else fields[0]++;

      count++;
    }

    let maior = fields.reduce((total, num) => (num > total ? num : total), 0);

    fields[5] = maior + maior * 0.1;

    setNotas(fields);
  }, [applications]);

  return (
    <>
      <div className="management-1statistics mb-5">
        <div className="row">
          <div className="chart">
            {notas && (
              <Charts
                legendY="Notas"
                legendX="Estudantes"
                type="horizontalbar"
                title=""
                data={{
                  labels: ["9 a 10", "7 a 9", "5 a 7", "3 a 5", "0 a 3"],
                  datasets: [
                    {
                      data: notas,
                      backgroundColor: [
                        "rgba(255, 99, 132, 0.2)",
                        "rgba(54, 162, 235, 0.2)",
                        "rgba(255, 206, 86, 0.2)",
                        "rgba(75, 192, 192, 0.2)",
                        "rgba(153, 102, 255, 0.2)",
                        "rgba(255, 159, 64, 0.2)"
                      ],
                      borderColor: [
                        "rgba(255, 99, 132, 1)",
                        "rgba(54, 162, 235, 1)",
                        "rgba(255, 206, 86, 1)",
                        "rgba(75, 192, 192, 1)",
                        "rgba(153, 102, 255, 1)",
                        "rgba(255, 159, 64, 1)"
                      ],
                      borderWidth: 1
                    }
                  ]
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="">
        <table className="table table-hover table-outline mb-0 d-none d-sm-table statistics">
          <thead className="thead-light">
            <tr>
              <th>Notas</th>
              <th>Estudantes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0 a 3</td>
              <td>{notas && notas[4] ? notas[4] : ""}</td>
            </tr>
            <tr>
              <td>3 a 5</td>
              <td>{notas && notas[3] ? notas[3] : ""}</td>
            </tr>
            <tr>
              <td>5 a 7</td>
              <td>{notas && notas[2] ? notas[2] : ""}</td>
            </tr>
            <tr>
              <td>7 a 9</td>
              <td>{notas && notas[1] ? notas[1] : ""}</td>
            </tr>
            <tr>
              <td>9 a 10</td>
              <td>{notas && notas[0] ? notas[0] : ""}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Chart1;
